import React from 'react';

import './GuessButton.css'

import { useDispatch } from 'react-redux';

import { guessStory } from 'Store/features/public/publicPuzzleSlice'

// import { CONFIG } from '../../../util/constants';

const GuessButton = (props) => {
  // Refactor into share and guess button separate
  const dispatch = useDispatch();
  const { guessable, gameOver, incorrectGuesses, time, modal, score } = props;
  const className = `guess-button ${guessable || gameOver ? 'guessable' : ''} ${modal ? 'modal' : ''}`;
  const minutes = Math.floor(time / 60);
  const seconds = time % 60 < 10 ? `0${time % 60}` : time % 60;
  // const url = CONFIG.WEB_APP_URI;
  const handleGuessClick = () => {
    if (gameOver) {
      if (navigator.share) {
        navigator.share({
          title: "Postcast",
          text: 'Play this game!',
          url: window.location.href
        }).then(() => {
          console.log('Thanks for sharing!');
        }).catch(console.error);
      } else {
        console.log('NO NAVI')
      }
    }
    else if (guessable) {
      dispatch(guessStory());
    }
  };
  return (<button className={className} onClick={handleGuessClick}>{gameOver ? 'Share' : 'Guess'}</button>)
};

export default GuessButton;